module.exports = __webpack_public_path__ + "static/img/MKD-logo3.4ca5dc1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/MKD-logo3.png
// module id = 1241
// module chunks = 169